/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1917583362 — Cancel-settle UX */

import { useMutation } from '@tanstack/react-query';

import { cancelOrder } from '../api/order.api';

// Give the apparatus this many ms to process the Cashless:6 we just sent
// before allowing any follow-up /api/connect. On SF4 the apparatus cancels
// the whole CardId session on Cashless:6, so a Cashless:1 published inside
// the cancel-processing window can get its device_status stamped to 6 by
// the apparatus's cancel-ack — see the Cancel-settle UX page linked above.
const CANCEL_SETTLE_DELAY_MS = 2000;

export const useCancelOrder = () => {
    return useMutation({
        mutationFn: async (orderId: string) => {
            await cancelOrder(orderId);
            await new Promise((resolve) =>
                setTimeout(resolve, CANCEL_SETTLE_DELAY_MS),
            );
        },
    });
};
